import React from 'react';
import autobind from "autobind-decorator";

import { PureComponent } from 'core/components';
import { EditProfilePage } from 'content/pages';

class EditProfile extends PureComponent {
  render() {
    return (
      <EditProfilePage
        navigate={this.$f7router}
      />
    );
  };
};

export default autobind(EditProfile);
